<template>

      <div class="tile is-child box">
        <div class="tags has-addons">
          <span class="tag  is-medium">Info</span>
          <span class="tag is-primary  is-medium">Member</span>
        </div>
        <table class="table is-hoverable is-fullwidth">
          <tbody>
            <tr>
              <th>Username</th>
              <td>{{ memberInfo.name }}</td>
            </tr>
            <tr>
              <th>Tag</th>
              <td>{{ memberInfo.tag }}</td>
            </tr>
            <tr>
              <th>Online status</th>
              <td>{{ memberInfo.onlineStatus }}</td>
            </tr>
            <tr>
              <th>Discord join date</th>
              <td>{{ memberInfo.discordJoinDate }}</td>
            </tr>
            <tr>
              <th>Guild join date</th>
              <td>{{ memberInfo.guildJoinDate }}</td>
            </tr>
          </tbody>
        </table>
      </div>
</template>

<script>
export default {
  name: 'MemberInfo',
  data: function() {
    return {
      bindNewPrefix: ''
    }
  },
  props: {
    memberInfo: null
  },
  methods: {
    setPrefix(prefix) {
      
      this.axios.get(this.$store.state.adress + '/changePrefix?token=' + this.$store.state.token + '&newPrefix=' + this.bindNewPrefix)
      .then((response) => {
        console.log(response.data);
        this.memberinfo = response.data.object;
      })
    }
  }
}
</script>

<style>
@import "~bulma/css/bulma.css";
</style>